// extracted by mini-css-extract-plugin
module.exports = {"alertMsg":"homepage_alertMsg__IMQ85","carousel":"homepage_carousel__1kI1m","slickslide":"homepage_slickslide__1xDqW"};